/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreateBusinessCustomerResultFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeCreateBusinessCustomerCommand, serializeCreateBusinessCustomerResult, type CreateBusinessCustomerCommand, type CreateBusinessCustomerResult, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type WithContractRequestBuilder, WithContractRequestBuilderRequestsMetadata } from './withContract/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/business
 */
export interface BusinessRequestBuilder extends BaseRequestBuilder<BusinessRequestBuilder> {
    /**
     * The withContract property
     */
    get withContract(): WithContractRequestBuilder;
    /**
     * CreateBusinessCustomer
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreateBusinessCustomerResult>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: CreateBusinessCustomerCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CreateBusinessCustomerResult | undefined>;
    /**
     * CreateBusinessCustomer
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateBusinessCustomerCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const BusinessRequestBuilderUriTemplate = "{+baseurl}/customers/business";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const BusinessRequestBuilderNavigationMetadata: Record<Exclude<keyof BusinessRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    withContract: {
        requestsMetadata: WithContractRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const BusinessRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: BusinessRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCreateBusinessCustomerResultFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateBusinessCustomerCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
